import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Shown for unknown URLs. "Home" goes to "/", which applies the normal landing
 * rules (last used module, module chooser, ...).
 */
export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
      px={2}
      textAlign="center"
      bgcolor="background.default"
    >
      <Typography variant="h1" component="p" color="primary" fontWeight={700} sx={{ fontSize: { xs: '4rem', sm: '5rem' }, lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h5" component="h1" fontWeight={600}>
        {t('common.notFound.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {t('common.notFound.description')}
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 1 }}>
        <Button variant="contained" startIcon={<HomeIcon />} onClick={() => navigate('/')}>
          {t('common.notFound.goHome')}
        </Button>
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)}>
          {t('common.back')}
        </Button>
      </Stack>
    </Box>
  );
};
